module.exports = __webpack_public_path__ + "static/pets-section-hammer-a0221bde9b6d36e71b2d22c2dbcabc02.png";